module.exports = __webpack_public_path__ + "static/media/amenities-2.e0b6d396.jpg";